import { Button, SimpleGrid } from '@mantine/core'
import { Link, useNavigate } from 'react-router-dom'
import ConfigBanner from '../../components/shared/ConfigBanner'
import PageHeader from '../../components/shared/PageHeader'
import Stat from '../../components/shared/Stat'
import { useCan, useResource } from '../../hooks'
import Message from '../../i18n/Message'
import { keys, loadAgentDashboard } from '../../store/dataActionCreators'

export default function AgentDashboard() {
  const { data } = useResource(keys.agentDashboard, loadAgentDashboard)
  const canRegister = useCan('customers.register')
  const navigate = useNavigate()
  const by = data?.applicationsByStatus || {}
  return (
    <>
      <PageHeader
        title="agent_dashboard_title"
        actions={
          canRegister && (
            <Button component={Link} to="/agent/applications/new">
              <Message id="new_application" />
            </Button>
          )
        }
      />
      <ConfigBanner blockingOnly />
      <SimpleGrid cols={{ base: 2, sm: 3, lg: 4 }}>
        <Stat label="stat_drafts" value={(by.draft || 0) + (by.corrections_requested || 0)} onClick={() => navigate('/agent/applications')} />
        <Stat label="stat_submitted" value={(by.submitted || 0) + (by.in_review || 0)} onClick={() => navigate('/agent/applications')} />
        <Stat label="stat_approved" value={by.approved || 0} onClick={() => navigate('/agent/applications')} />
        <Stat label="stat_customers" value={data?.customers} onClick={() => navigate('/agent/customers')} />
        <Stat label="stat_due_week" value={data?.dueThisWeek} onClick={() => navigate('/agent/repayments')} />
        <Stat label="stat_overdue" value={data?.overdueLoans} onClick={() => navigate('/agent/repayments')} />
        <Stat label="stat_pending_payments" value={data?.pendingPayments} />
      </SimpleGrid>
    </>
  )
}
